import { render, staticRenderFns } from "./law-enforcement-enquiry.vue?vue&type=template&id=41fe47ea&"
import script from "./law-enforcement-enquiry.vue?vue&type=script&lang=js&"
export * from "./law-enforcement-enquiry.vue?vue&type=script&lang=js&"
import style0 from "./law-enforcement-enquiry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports